import wamp, { submitSimulation, getResults } from './wamp';

async function boardSubmitSimulation(board, project, store) {
  board.simulationProgress = 0;

  try {
    board.activeSimulation = true;
    board.simulationResults = [];
    board.thresholdResults = [];

    const job = await submitSimulation(project.id, board.id);

    job.onEvent = (event) => {
      if (event.type === 'log' && event.message.startsWith('Progress: ')) {
        board.simulationProgress = parseFloat(event.message.replace('Progress: ', ''));
      }
    };

    const exitEvent: any = await job.exitPromise;

    const upload = await getResults(job.id);

    board.simulationProgress = 0;

    const result = upload.result;

    board.activeSimulation = false;
    board.setSimulationResult(result, project);

    if (result.status === 0) {
      store.commit('updateMeshFileUrl', {
        boardIndex: board.index,
        meshFileUrl: `/uploads/${upload.meshFileInfo.filename}`,
      });
    }
  } catch (e) {
    board.activeSimulation = false;
    console.log(`submitSimulation failed!`, e);
    throw e;
  }
}


export { boardSubmitSimulation };



// WEBPACK FOOTER //
// ./src/simulation.ts